// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
#root {
    min-height: 100%;
}

body {
    margin: 0;
    font-family: 'Roboto', sans-serif; /* Example using Roboto font */
    background: #f5f7fb;
    color: #172033;
}

button,
input,
select,
textarea {
    font: inherit;
}

.app-shell {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: #f5f7fb;
}

.app-header {
    position: sticky;
    top: 0;
    z-index: 30;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 22px;
    background: #06233f;
    color: #fff;
    box-shadow: 0 8px 24px rgba(6, 35, 63, 0.14);
}

.header-left,
.header-right,
.header-user-summary,
.header-user-copy {
    display: flex;
    align-items: center;
}

.header-left {
    gap: 16px;
}

.header-right {
    gap: 14px;
    min-width: 0;
}

.sidebar-toggle-button,
.header-logout-button {
    width: 40px;
    height: 40px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
}

.sidebar-toggle-button:hover,
.header-logout-button:hover {
    background: rgba(255, 255, 255, 0.16);
    border-color: rgba(255, 255, 255, 0.28);
}

.sidebar-toggle-button:active,
.header-logout-button:active {
    transform: translateY(1px);
}

.header-logo-link {
    display: inline-flex;
    align-items: center;
    height: 48px;
}

.header-logo {
    height: 48px;
    width: 132px;
    object-fit: contain;
    display: block;
}

.header-user-summary {
    min-width: 0;
    gap: 10px;
}

.header-user-avatar {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #e6eef7;
    color: #06233f;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
}

.header-user-copy {
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
}

.header-user-name,
.header-user-email {
    max-width: 260px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.header-user-name {
    font-size: 14px;
    font-weight: 700;
    line-height: 1.2;
}

.header-user-email {
    margin-top: 3px;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.72);
}

.header-role-badge {
    max-width: 170px;
    padding: 5px 9px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.12);
    color: rgba(255, 255, 255, 0.9);
    font-size: 12px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.app-body {
    flex: 1 1;
    display: flex;
    min-height: 0;
}

.left-bar {
    position: sticky;
    top: 72px;
    z-index: 20;
    width: 238px;
    flex: 0 0 238px;
    height: calc(100vh - 72px);
    overflow-y: auto;
    padding: 18px 12px;
    background: #ffffff;
    border-right: 1px solid #e5ebf3;
    box-shadow: 8px 0 22px rgba(9, 30, 66, 0.04);
    transition: width 0.2s ease, flex-basis 0.2s ease, transform 0.2s ease;
}

.left-bar.collapsed {
    width: 76px;
    flex-basis: 76px;
}

.left-bar-header {
    display: flex;
    flex-direction: column;
    padding: 8px 10px 16px;
    gap: 3px;
}

.left-bar-kicker {
    font-size: 11px;
    font-weight: 700;
    color: #7b8798;
    letter-spacing: 0;
    text-transform: uppercase;
}

.left-bar-title {
    color: #172033;
    font-size: 18px;
    font-weight: 800;
}

.left-bar-menu {
    list-style: none;
    margin: 0;
    padding: 0;
}

.left-bar-menu-item {
    margin-bottom: 6px;
}

.left-bar-link {
    min-height: 44px;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 8px;
    color: #3b4658;
    text-decoration: none;
    font-size: 14px;
    font-weight: 700;
    transition: background 0.18s ease, color 0.18s ease;
}

.left-bar-link:hover {
    background: #f0f4f8;
    color: #06233f;
}

.left-bar-link.active {
    background: #e8f1fb;
    color: #06233f;
}

.left-bar-icon {
    width: 20px;
    display: inline-flex;
    justify-content: center;
    color: inherit;
    flex: 0 0 20px;
}

.left-bar-label {
    min-width: 0;
    white-space: normal;
    line-height: 1.2;
}

.left-bar.collapsed .left-bar-header {
    align-items: center;
    padding-left: 0;
    padding-right: 0;
}

.left-bar.collapsed .left-bar-kicker,
.left-bar.collapsed .left-bar-title,
.left-bar.collapsed .left-bar-label {
    display: none;
}

.left-bar.collapsed .left-bar-link {
    justify-content: center;
    padding-left: 0;
    padding-right: 0;
}

.app-content {
    flex: 1 1;
    min-width: 0;
    display: flex;
    padding: 24px 28px;
    overflow-x: auto;
}

.app-content > * {
    min-width: 0;
}

.app-content > .container {
    margin-left: 0;
    max-width: 100%;
}

.sidebar-backdrop {
    display: none;
}

.page-heading-row {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 22px;
}

.page-heading-copy {
    min-width: 0;
}

.page-kicker {
    display: inline-block;
    margin-bottom: 6px;
    color: #697789;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0;
    text-transform: uppercase;
}

.page-heading-copy h1,
.invoice-detail-title-group h1 {
    margin: 0;
    color: #121b2d;
    font-size: 28px;
    font-weight: 800;
    line-height: 1.15;
    letter-spacing: 0;
}

.page-heading-copy p,
.invoice-detail-title-group p,
.modal-helper-copy {
    margin: 8px 0 0;
    color: #697789;
    font-size: 14px;
    line-height: 1.5;
}

.page-metrics-panel {
    min-width: min(100%, 720px);
}

.page-metrics-title {
    display: block;
    margin-bottom: 7px;
    color: #697789;
    font-size: 11px;
    font-weight: 800;
    line-height: 1.2;
    text-transform: uppercase;
}

.page-metrics {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr));
    gap: 10px;
}

.page-metric {
    min-width: 150px;
    padding: 10px 12px;
    border: 1px solid #e3eaf3;
    border-radius: 8px;
    background: #ffffff;
}

.page-metric-value,
.page-metric-label {
    display: block;
}

.page-metric-value {
    color: #10213a;
    font-size: 20px;
    font-weight: 800;
    line-height: 1.1;
}

.page-metric-label {
    margin-top: 4px;
    color: #6e7c8f;
    font-size: 11px;
    font-weight: 700;
    line-height: 1.25;
    text-transform: uppercase;
}

.invoice-history-page {
    width: 100%;
    max-width: none;
}

.invoice-detail-page {
    width: 100%;
    max-width: 1480px;
}

.invoice-history-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 14px;
}

.invoice-history-search {
    width: min(100%, 340px);
}

.invoice-history-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

.column-checkbox-group {
    max-width: 260px;
    padding: 8px 10px;
    display: grid;
    gap: 8px;
}

.invoice-table-shell {
    width: 100%;
    border: 1px solid #e2e9f2;
    border-radius: 8px;
    background: #ffffff;
    overflow: hidden;
}

.invoice-history-table .ant-table {
    background: #ffffff;
}

.invoice-history-table .ant-table-thead > tr > th {
    background: #f8fafc;
    color: #314056;
    font-size: 12px;
    font-weight: 800;
    white-space: nowrap;
}

.invoice-history-table .ant-table-tbody > tr > td {
    color: #263349;
    font-size: 13px;
}

.invoice-history-table .ant-table-tbody > tr:hover > td {
    background: #f5f9fd;
    cursor: pointer;
}

.invoice-detail-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 18px;
    margin-bottom: 18px;
}

.invoice-detail-title-group {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    min-width: 0;
}

.detail-back-button {
    min-height: 40px;
    padding: 0 13px;
    border: 1px solid #dbe4ee;
    border-radius: 8px;
    background: #ffffff;
    color: #24324a;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 700;
    transition: background 0.18s ease, border-color 0.18s ease;
}

.detail-back-button:hover {
    background: #f3f6fa;
    border-color: #cbd7e4;
}

.invoice-detail-header-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.invoice-status-tag {
    margin-inline-end: 0;
    padding: 4px 9px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 800;
}

.invoice-detail-layout {
    display: grid;
    grid-template-columns: minmax(380px, 1fr) minmax(360px, 0.9fr);
    gap: 18px;
    align-items: start;
}

.invoice-preview-panel,
.invoice-workflow-panel {
    min-width: 0;
    border: 1px solid #e2e9f2;
    border-radius: 8px;
    background: #ffffff;
}

.invoice-preview-panel {
    min-height: 680px;
    overflow: auto;
    padding: 0;
}

.invoice-workflow-panel {
    padding: 18px;
}

.invoice-workflow-panel textarea,
.invoice-workflow-panel .ant-input {
    border-radius: 8px;
}

.invoice-workflow-panel .ant-divider {
    border-color: #e6edf5;
}

.invoice-workflow-panel .ant-space {
    flex-wrap: wrap;
}

.invoice-workflow-panel .invoice-container {
    padding: 0;
    margin-left: 0;
}

.invoice-workflow-panel .input-group {
    flex-wrap: wrap;
    gap: 8px;
}

.invoice-workflow-panel .input-group label {
    min-width: 100%;
    margin: 0;
    color: #3c4a5f;
    font-size: 13px;
    font-weight: 800;
}

.invoice-workflow-panel .input-group .ant-select,
.invoice-workflow-panel .input-group input {
    width: 100% !important;
}

.invoice-workflow-panel .add-vendor {
    width: 100%;
}

.approval-workflow-form {
    min-width: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.approval-workflow-heading h2 {
    margin: 0;
    color: #172033;
    font-size: 20px;
    font-weight: 800;
    line-height: 1.2;
}

.approval-workflow-section {
    min-width: 0;
    padding: 14px;
    border: 1px solid #e7edf5;
    border-radius: 8px;
    background: #fbfdff;
}

.approval-section-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
}

.approval-section-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.approval-section-kicker {
    color: #6a788c;
    font-size: 11px;
    font-weight: 800;
    line-height: 1.2;
    text-transform: uppercase;
}

.approval-section-person {
    min-width: 0;
    color: #172033;
    font-size: 14px;
    font-weight: 800;
    line-height: 1.3;
    overflow-wrap: anywhere;
}

.approval-date-chip {
    flex: 0 0 auto;
    padding: 4px 8px;
    border-radius: 999px;
    background: #edf4fb;
    color: #56657a;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
}

.approval-textarea {
    display: block;
    min-height: 106px !important;
    max-width: 100%;
    background: #ffffff;
    transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.approval-textarea:focus {
    border-color: #1f6feb !important;
    box-shadow: 0 0 0 3px rgba(31, 111, 235, 0.12);
}

.approval-textarea:disabled {
    background: #f5f8fb;
    color: #56657a;
    cursor: not-allowed;
}

.approval-tabs {
    min-width: 0;
}

.approval-workflow-tabs .ant-tabs-nav {
    margin-bottom: 12px;
}

.approval-workflow-tabs .ant-tabs-tab {
    padding: 8px 0;
}

.approval-workflow-tabs .ant-tabs-tab-btn {
    color: #3d4b61;
    font-weight: 800;
}

.approval-divider {
    margin: 0;
    border-color: #e6edf5;
}

.approval-controller-form {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.approval-checkbox {
    color: #3d4b61;
    font-weight: 700;
}

.approval-action-row {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
}

.approval-action-button {
    min-height: 38px;
    border-radius: 8px;
    font-weight: 800;
}

.approval-action-button.mark-paid:not(:disabled) {
    border-color: #24a148;
    background: #24a148;
    color: #ffffff;
}

.approval-action-button.mark-paid:not(:disabled):hover {
    border-color: #1f8f3f;
    background: #1f8f3f;
    color: #ffffff;
}

.pdf-viewer-frame {
    width: 100%;
    min-height: 640px;
    display: flex;
    align-items: stretch;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 18px;
    background: #f7f9fc;
    overflow: hidden;
}

.pdf-viewer-embed {
    width: min(100%, 860px);
    max-width: 100%;
    height: calc(100vh - 260px);
    min-height: 640px;
    border: 0;
    display: block;
    background: #ffffff;
}

.invoice-preview-panel .pdf-viewer-frame {
    min-height: 680px;
}

.invoice-preview-panel .pdf-viewer-embed {
    height: calc(100vh - 270px);
    min-height: 680px;
}

.invoice-create-page,
.management-page {
    width: 100%;
    max-width: 1480px;
}

.invoice-create-page .step-indicator,
.invoice-create-page [class*="step"] {
    max-width: 760px;
}

.invoice-upload-card {
    max-width: 640px;
    min-height: 260px;
    margin-top: 18px;
    padding: 32px;
    border: 1px dashed #9ab2c9;
    border-radius: 8px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}

.upload-card-kicker {
    margin-bottom: 8px;
    color: #64748b;
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
}

.invoice-upload-card h2 {
    margin: 0;
    color: #172033;
    font-size: 26px;
    font-weight: 800;
}

.invoice-upload-card p {
    max-width: 460px;
    margin: 10px 0 20px;
    color: #66758a;
    font-size: 14px;
    line-height: 1.55;
}

.primary-action-button {
    min-height: 40px;
    padding: 0 16px;
    border: 0;
    border-radius: 8px;
    background: #1f6feb;
    color: #ffffff;
    cursor: pointer;
    font-size: 14px;
    font-weight: 800;
}

.primary-action-button:hover {
    background: #195fc8;
}

.invoice-create-workspace {
    margin-top: 18px;
}

.invoice-create-toolbar {
    margin-bottom: 14px;
}

.invoice-submit-layout {
    display: grid;
    grid-template-columns: minmax(420px, 1.25fr) minmax(360px, 0.75fr);
    gap: 18px;
    align-items: start;
}

.invoice-create-layout {
    display: grid;
    grid-template-columns: minmax(380px, 1fr) minmax(360px, 0.9fr);
    gap: 18px;
    align-items: start;
}

.invoice-form-panel,
.invoice-submit-panel,
.invoice-approval-panel {
    min-width: 0;
    border: 1px solid #e2e9f2;
    border-radius: 8px;
    background: #ffffff;
    padding: 18px;
}

.invoice-form-panel .invoice-container {
    margin-left: 0;
    padding: 0;
}

.invoice-form-panel .input-group,
.invoice-form-panel .input-group-small {
    flex-wrap: wrap;
    gap: 8px;
}

.invoice-form-panel .input-group label,
.invoice-form-panel .input-group-small label {
    min-width: 100%;
    margin: 0;
    color: #3c4a5f;
    font-size: 13px;
    font-weight: 800;
}

.invoice-form-panel .input-group .ant-select,
.invoice-form-panel .input-group-small .ant-select,
.invoice-form-panel .input-group input,
.invoice-form-panel .input-group-small input {
    width: 100% !important;
}

.invoice-form-panel .submit-button,
.submit-form button {
    width: 100% !important;
    margin-left: 0 !important;
    border-radius: 8px !important;
}

.invoice-form-panel .add-vendor {
    width: 100%;
}

.invoice-submit-layout {
    margin-top: 18px;
}

.invoice-submit-panel .container {
    margin: 0;
}

.invoice-submit-panel .back-button-container {
    margin: 0 0 16px;
}

.invoice-submit-panel .back-button {
    border: 1px solid #dbe4ee;
    background: #ffffff;
}

.invoice-approval-panel .controller-form {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 0;
    background: transparent;
    border-radius: 0;
}

.invoice-approval-panel .input-group-controller {
    flex-direction: column;
    gap: 8px;
    margin: 0;
}

.invoice-approval-panel .input-group-controller label {
    margin: 0;
    align-self: flex-start;
    color: #3c4a5f;
    font-size: 13px;
    font-weight: 800;
}

.invoice-approval-panel .input-group-controller .ant-select {
    width: 100% !important;
    margin: 0;
}

.management-grid {
    display: grid;
    grid-template-columns: minmax(300px, 360px) minmax(0, 1fr);
    gap: 18px;
    align-items: start;
}

.management-form-card,
.management-list-card,
.role-assignment-card {
    min-width: 0;
    border: 1px solid #e2e9f2;
    border-radius: 8px;
    background: #ffffff;
    padding: 18px;
}

.management-list-card.full-width {
    width: 100%;
}

.card-heading {
    margin-bottom: 16px;
}

.card-heading h2,
.list-panel-heading h2 {
    margin: 0;
    color: #172033;
    font-size: 18px;
    font-weight: 800;
}

.card-heading p,
.list-panel-heading p {
    margin: 6px 0 0;
    color: #68778c;
    font-size: 13px;
    line-height: 1.45;
}

.compact-form form {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.form-field {
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.form-field span {
    color: #3c4a5f;
    font-size: 13px;
    font-weight: 800;
}

.list-panel-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin-bottom: 14px;
}

.list-panel-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.list-search {
    width: min(320px, 100%);
}

.list-panel-actions .ant-select {
    width: 220px;
}

.data-table-shell {
    border: 1px solid #e2e9f2;
    border-radius: 8px;
    background: #ffffff;
    overflow: hidden;
}

.management-table .ant-table-thead > tr > th {
    background: #f8fafc;
    color: #314056;
    font-size: 12px;
    font-weight: 800;
    white-space: nowrap;
}

.management-table .ant-table-tbody > tr > td {
    color: #263349;
    font-size: 13px;
}

.management-table .ant-table-tbody > tr:hover > td {
    background: #f5f9fd;
    cursor: pointer;
}

.management-table .ant-select {
    width: 100%;
}

.role-assignment-card {
    margin-bottom: 16px;
}

.role-assignment-toolbar {
    display: grid;
    grid-template-columns: minmax(240px, 1fr) minmax(220px, 0.6fr) auto;
    gap: 10px;
}

@media (max-width: 768px) {
    .app-header {
        height: 64px;
        padding: 0 14px;
    }

    .header-left {
        gap: 10px;
    }

    .header-logo {
        width: 116px;
        height: 42px;
    }

    .header-user-email,
    .header-role-badge {
        display: none;
    }

    .header-user-name {
        max-width: 120px;
        font-size: 13px;
    }

    .header-user-avatar {
        width: 34px;
        height: 34px;
        font-size: 12px;
    }

    .sidebar-toggle-button,
    .header-logout-button {
        width: 38px;
        height: 38px;
    }

    .left-bar,
    .left-bar.collapsed {
        position: fixed;
        top: 64px;
        left: 0;
        bottom: 0;
        z-index: 50;
        width: 260px;
        height: calc(100vh - 64px);
        flex-basis: auto;
        transform: translateX(-100%);
        box-shadow: 18px 0 32px rgba(9, 30, 66, 0.18);
    }

    .left-bar.mobile-open {
        transform: translateX(0);
    }

    .left-bar.collapsed .left-bar-header {
        align-items: flex-start;
        padding: 8px 10px 16px;
    }

    .left-bar.collapsed .left-bar-kicker,
    .left-bar.collapsed .left-bar-title,
    .left-bar.collapsed .left-bar-label {
        display: inline;
    }

    .left-bar.collapsed .left-bar-link {
        justify-content: flex-start;
        padding: 10px 12px;
    }

    .app-content {
        width: 100%;
        padding: 16px;
    }

    .page-heading-row,
    .invoice-detail-header,
    .invoice-history-toolbar {
        align-items: stretch;
        flex-direction: column;
    }

    .page-metrics {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: 100%;
    }

    .invoice-history-search,
    .invoice-history-actions {
        width: 100%;
    }

    .invoice-history-actions {
        justify-content: stretch;
    }

    .invoice-history-actions .ant-btn {
        flex: 1 1;
    }

    .invoice-table-shell {
        overflow: visible;
    }

    .invoice-history-table .ant-table {
        border: 1px solid #e2e9f2;
        border-radius: 8px;
        overflow: hidden;
    }

    .invoice-history-table .ant-table-pagination.ant-pagination {
        justify-content: center;
        flex-wrap: wrap;
        gap: 6px 4px;
        margin: 14px 0 0;
    }

    .invoice-history-table .ant-pagination-options {
        display: none;
    }

    .invoice-detail-title-group {
        flex-direction: column;
    }

    .invoice-detail-header-actions {
        justify-content: flex-start;
    }

    .invoice-detail-layout {
        grid-template-columns: 1fr;
    }

    .invoice-create-layout,
    .invoice-submit-layout,
    .management-grid {
        grid-template-columns: 1fr;
    }

    .invoice-preview-panel {
        min-height: 520px;
    }

    .pdf-viewer-frame,
    .pdf-viewer-embed,
    .invoice-preview-panel .pdf-viewer-frame,
    .invoice-preview-panel .pdf-viewer-embed {
        min-height: 520px;
        height: 520px;
    }

    .list-panel-heading,
    .list-panel-actions,
    .role-assignment-toolbar {
        align-items: stretch;
        grid-template-columns: 1fr;
        flex-direction: column;
    }

    .list-search {
        width: 100%;
    }

    .sidebar-backdrop {
        position: fixed;
        top: 64px;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 45;
        display: block;
        border: 0;
        background: rgba(8, 24, 43, 0.42);
        cursor: pointer;
    }
}

@media (max-width: 520px) {
    .header-user-copy {
        display: none;
    }

    .app-content {
        padding: 12px;
    }

    .page-metrics {
        grid-template-columns: 1fr;
    }

    .page-heading-copy h1,
    .invoice-detail-title-group h1 {
        font-size: 24px;
    }

    .invoice-workflow-panel {
        padding: 14px;
    }

    .approval-action-row {
        grid-template-columns: 1fr;
    }

    .invoice-upload-card,
    .management-form-card,
    .management-list-card,
    .role-assignment-card,
    .invoice-form-panel,
    .invoice-submit-panel,
    .invoice-approval-panel {
        padding: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Global.css"],"names":[],"mappings":"AAAA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iCAAiC,EAAE,8BAA8B;IACjE,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;;IAII,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,4CAA4C;AAChD;;AAEA;;;;IAII,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,6EAA6E;AACjF;;AAEA;;IAEI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,qCAAqC;IACrC,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,4CAA4C;IAC5C,sEAAsE;AAC1E;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,uBAAuB;IACvB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;;IAEI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;;;IAGI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,0DAA0D;AAC9D;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8DAA8D;IAC9D,SAAS;IACT,kBAAkB;AACtB;;AAEA;;IAEI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;IACnB,iFAAiF;AACrF;;AAEA;IACI,gCAAgC;IAChC,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,SAAS;IACT,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kEAAkE;IAClE,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8DAA8D;IAC9D,SAAS;IACT,kBAAkB;AACtB;;AAEA;;;IAGI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;;IAEI,eAAe;IACf,QAAQ;AACZ;;AAEA;;IAEI,eAAe;IACf,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;;IAII,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,0DAA0D;IAC1D,SAAS;IACT,kBAAkB;AACtB;;AAEA;;;IAGI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mEAAmE;IACnE,SAAS;AACb;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,eAAe;QACf,SAAS;QACT,OAAO;QACP,SAAS;QACT,WAAW;QACX,YAAY;QACZ,0BAA0B;QAC1B,gBAAgB;QAChB,4BAA4B;QAC5B,6CAA6C;IACjD;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;;;QAGI,eAAe;IACnB;;IAEA;QACI,2BAA2B;QAC3B,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;;;QAGI,oBAAoB;QACpB,sBAAsB;IAC1B;;IAEA;QACI,gDAAgD;QAChD,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;QACvB,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;;QAGI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;;;QAII,iBAAiB;QACjB,aAAa;IACjB;;IAEA;;;QAGI,oBAAoB;QACpB,0BAA0B;QAC1B,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,SAAS;QACT,QAAQ;QACR,SAAS;QACT,OAAO;QACP,WAAW;QACX,cAAc;QACd,SAAS;QACT,iCAAiC;QACjC,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;;;;;;;QAOI,aAAa;IACjB;AACJ","sourcesContent":["html,\n#root {\n    min-height: 100%;\n}\n\nbody {\n    margin: 0;\n    font-family: 'Roboto', sans-serif; /* Example using Roboto font */\n    background: #f5f7fb;\n    color: #172033;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n    font: inherit;\n}\n\n.app-shell {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    background: #f5f7fb;\n}\n\n.app-header {\n    position: sticky;\n    top: 0;\n    z-index: 30;\n    height: 72px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 22px;\n    background: #06233f;\n    color: #fff;\n    box-shadow: 0 8px 24px rgba(6, 35, 63, 0.14);\n}\n\n.header-left,\n.header-right,\n.header-user-summary,\n.header-user-copy {\n    display: flex;\n    align-items: center;\n}\n\n.header-left {\n    gap: 16px;\n}\n\n.header-right {\n    gap: 14px;\n    min-width: 0;\n}\n\n.sidebar-toggle-button,\n.header-logout-button {\n    width: 40px;\n    height: 40px;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    border-radius: 8px;\n    background: rgba(255, 255, 255, 0.08);\n    color: #fff;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;\n}\n\n.sidebar-toggle-button:hover,\n.header-logout-button:hover {\n    background: rgba(255, 255, 255, 0.16);\n    border-color: rgba(255, 255, 255, 0.28);\n}\n\n.sidebar-toggle-button:active,\n.header-logout-button:active {\n    transform: translateY(1px);\n}\n\n.header-logo-link {\n    display: inline-flex;\n    align-items: center;\n    height: 48px;\n}\n\n.header-logo {\n    height: 48px;\n    width: 132px;\n    object-fit: contain;\n    display: block;\n}\n\n.header-user-summary {\n    min-width: 0;\n    gap: 10px;\n}\n\n.header-user-avatar {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    background: #e6eef7;\n    color: #06233f;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n\n.header-user-copy {\n    flex-direction: column;\n    align-items: flex-start;\n    min-width: 0;\n}\n\n.header-user-name,\n.header-user-email {\n    max-width: 260px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.header-user-name {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n.header-user-email {\n    margin-top: 3px;\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.72);\n}\n\n.header-role-badge {\n    max-width: 170px;\n    padding: 5px 9px;\n    border-radius: 999px;\n    background: rgba(255, 255, 255, 0.12);\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 12px;\n    font-weight: 700;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.app-body {\n    flex: 1;\n    display: flex;\n    min-height: 0;\n}\n\n.left-bar {\n    position: sticky;\n    top: 72px;\n    z-index: 20;\n    width: 238px;\n    flex: 0 0 238px;\n    height: calc(100vh - 72px);\n    overflow-y: auto;\n    padding: 18px 12px;\n    background: #ffffff;\n    border-right: 1px solid #e5ebf3;\n    box-shadow: 8px 0 22px rgba(9, 30, 66, 0.04);\n    transition: width 0.2s ease, flex-basis 0.2s ease, transform 0.2s ease;\n}\n\n.left-bar.collapsed {\n    width: 76px;\n    flex-basis: 76px;\n}\n\n.left-bar-header {\n    display: flex;\n    flex-direction: column;\n    padding: 8px 10px 16px;\n    gap: 3px;\n}\n\n.left-bar-kicker {\n    font-size: 11px;\n    font-weight: 700;\n    color: #7b8798;\n    letter-spacing: 0;\n    text-transform: uppercase;\n}\n\n.left-bar-title {\n    color: #172033;\n    font-size: 18px;\n    font-weight: 800;\n}\n\n.left-bar-menu {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.left-bar-menu-item {\n    margin-bottom: 6px;\n}\n\n.left-bar-link {\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    color: #3b4658;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 700;\n    transition: background 0.18s ease, color 0.18s ease;\n}\n\n.left-bar-link:hover {\n    background: #f0f4f8;\n    color: #06233f;\n}\n\n.left-bar-link.active {\n    background: #e8f1fb;\n    color: #06233f;\n}\n\n.left-bar-icon {\n    width: 20px;\n    display: inline-flex;\n    justify-content: center;\n    color: inherit;\n    flex: 0 0 20px;\n}\n\n.left-bar-label {\n    min-width: 0;\n    white-space: normal;\n    line-height: 1.2;\n}\n\n.left-bar.collapsed .left-bar-header {\n    align-items: center;\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.left-bar.collapsed .left-bar-kicker,\n.left-bar.collapsed .left-bar-title,\n.left-bar.collapsed .left-bar-label {\n    display: none;\n}\n\n.left-bar.collapsed .left-bar-link {\n    justify-content: center;\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.app-content {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    padding: 24px 28px;\n    overflow-x: auto;\n}\n\n.app-content > * {\n    min-width: 0;\n}\n\n.app-content > .container {\n    margin-left: 0;\n    max-width: 100%;\n}\n\n.sidebar-backdrop {\n    display: none;\n}\n\n.page-heading-row {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 24px;\n    margin-bottom: 22px;\n}\n\n.page-heading-copy {\n    min-width: 0;\n}\n\n.page-kicker {\n    display: inline-block;\n    margin-bottom: 6px;\n    color: #697789;\n    font-size: 12px;\n    font-weight: 800;\n    letter-spacing: 0;\n    text-transform: uppercase;\n}\n\n.page-heading-copy h1,\n.invoice-detail-title-group h1 {\n    margin: 0;\n    color: #121b2d;\n    font-size: 28px;\n    font-weight: 800;\n    line-height: 1.15;\n    letter-spacing: 0;\n}\n\n.page-heading-copy p,\n.invoice-detail-title-group p,\n.modal-helper-copy {\n    margin: 8px 0 0;\n    color: #697789;\n    font-size: 14px;\n    line-height: 1.5;\n}\n\n.page-metrics-panel {\n    min-width: min(100%, 720px);\n}\n\n.page-metrics-title {\n    display: block;\n    margin-bottom: 7px;\n    color: #697789;\n    font-size: 11px;\n    font-weight: 800;\n    line-height: 1.2;\n    text-transform: uppercase;\n}\n\n.page-metrics {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(150px, 1fr));\n    gap: 10px;\n}\n\n.page-metric {\n    min-width: 150px;\n    padding: 10px 12px;\n    border: 1px solid #e3eaf3;\n    border-radius: 8px;\n    background: #ffffff;\n}\n\n.page-metric-value,\n.page-metric-label {\n    display: block;\n}\n\n.page-metric-value {\n    color: #10213a;\n    font-size: 20px;\n    font-weight: 800;\n    line-height: 1.1;\n}\n\n.page-metric-label {\n    margin-top: 4px;\n    color: #6e7c8f;\n    font-size: 11px;\n    font-weight: 700;\n    line-height: 1.25;\n    text-transform: uppercase;\n}\n\n.invoice-history-page {\n    width: 100%;\n    max-width: none;\n}\n\n.invoice-detail-page {\n    width: 100%;\n    max-width: 1480px;\n}\n\n.invoice-history-toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    margin-bottom: 14px;\n}\n\n.invoice-history-search {\n    width: min(100%, 340px);\n}\n\n.invoice-history-actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.column-checkbox-group {\n    max-width: 260px;\n    padding: 8px 10px;\n    display: grid;\n    gap: 8px;\n}\n\n.invoice-table-shell {\n    width: 100%;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    background: #ffffff;\n    overflow: hidden;\n}\n\n.invoice-history-table .ant-table {\n    background: #ffffff;\n}\n\n.invoice-history-table .ant-table-thead > tr > th {\n    background: #f8fafc;\n    color: #314056;\n    font-size: 12px;\n    font-weight: 800;\n    white-space: nowrap;\n}\n\n.invoice-history-table .ant-table-tbody > tr > td {\n    color: #263349;\n    font-size: 13px;\n}\n\n.invoice-history-table .ant-table-tbody > tr:hover > td {\n    background: #f5f9fd;\n    cursor: pointer;\n}\n\n.invoice-detail-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 18px;\n    margin-bottom: 18px;\n}\n\n.invoice-detail-title-group {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    min-width: 0;\n}\n\n.detail-back-button {\n    min-height: 40px;\n    padding: 0 13px;\n    border: 1px solid #dbe4ee;\n    border-radius: 8px;\n    background: #ffffff;\n    color: #24324a;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 14px;\n    font-weight: 700;\n    transition: background 0.18s ease, border-color 0.18s ease;\n}\n\n.detail-back-button:hover {\n    background: #f3f6fa;\n    border-color: #cbd7e4;\n}\n\n.invoice-detail-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n}\n\n.invoice-status-tag {\n    margin-inline-end: 0;\n    padding: 4px 9px;\n    border-radius: 999px;\n    font-size: 12px;\n    font-weight: 800;\n}\n\n.invoice-detail-layout {\n    display: grid;\n    grid-template-columns: minmax(380px, 1fr) minmax(360px, 0.9fr);\n    gap: 18px;\n    align-items: start;\n}\n\n.invoice-preview-panel,\n.invoice-workflow-panel {\n    min-width: 0;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    background: #ffffff;\n}\n\n.invoice-preview-panel {\n    min-height: 680px;\n    overflow: auto;\n    padding: 0;\n}\n\n.invoice-workflow-panel {\n    padding: 18px;\n}\n\n.invoice-workflow-panel textarea,\n.invoice-workflow-panel .ant-input {\n    border-radius: 8px;\n}\n\n.invoice-workflow-panel .ant-divider {\n    border-color: #e6edf5;\n}\n\n.invoice-workflow-panel .ant-space {\n    flex-wrap: wrap;\n}\n\n.invoice-workflow-panel .invoice-container {\n    padding: 0;\n    margin-left: 0;\n}\n\n.invoice-workflow-panel .input-group {\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.invoice-workflow-panel .input-group label {\n    min-width: 100%;\n    margin: 0;\n    color: #3c4a5f;\n    font-size: 13px;\n    font-weight: 800;\n}\n\n.invoice-workflow-panel .input-group .ant-select,\n.invoice-workflow-panel .input-group input {\n    width: 100% !important;\n}\n\n.invoice-workflow-panel .add-vendor {\n    width: 100%;\n}\n\n.approval-workflow-form {\n    min-width: 0;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.approval-workflow-heading h2 {\n    margin: 0;\n    color: #172033;\n    font-size: 20px;\n    font-weight: 800;\n    line-height: 1.2;\n}\n\n.approval-workflow-section {\n    min-width: 0;\n    padding: 14px;\n    border: 1px solid #e7edf5;\n    border-radius: 8px;\n    background: #fbfdff;\n}\n\n.approval-section-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 10px;\n}\n\n.approval-section-copy {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.approval-section-kicker {\n    color: #6a788c;\n    font-size: 11px;\n    font-weight: 800;\n    line-height: 1.2;\n    text-transform: uppercase;\n}\n\n.approval-section-person {\n    min-width: 0;\n    color: #172033;\n    font-size: 14px;\n    font-weight: 800;\n    line-height: 1.3;\n    overflow-wrap: anywhere;\n}\n\n.approval-date-chip {\n    flex: 0 0 auto;\n    padding: 4px 8px;\n    border-radius: 999px;\n    background: #edf4fb;\n    color: #56657a;\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 1.2;\n    white-space: nowrap;\n}\n\n.approval-textarea {\n    display: block;\n    min-height: 106px !important;\n    max-width: 100%;\n    background: #ffffff;\n    transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;\n}\n\n.approval-textarea:focus {\n    border-color: #1f6feb !important;\n    box-shadow: 0 0 0 3px rgba(31, 111, 235, 0.12);\n}\n\n.approval-textarea:disabled {\n    background: #f5f8fb;\n    color: #56657a;\n    cursor: not-allowed;\n}\n\n.approval-tabs {\n    min-width: 0;\n}\n\n.approval-workflow-tabs .ant-tabs-nav {\n    margin-bottom: 12px;\n}\n\n.approval-workflow-tabs .ant-tabs-tab {\n    padding: 8px 0;\n}\n\n.approval-workflow-tabs .ant-tabs-tab-btn {\n    color: #3d4b61;\n    font-weight: 800;\n}\n\n.approval-divider {\n    margin: 0;\n    border-color: #e6edf5;\n}\n\n.approval-controller-form {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.approval-checkbox {\n    color: #3d4b61;\n    font-weight: 700;\n}\n\n.approval-action-row {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    gap: 8px;\n}\n\n.approval-action-button {\n    min-height: 38px;\n    border-radius: 8px;\n    font-weight: 800;\n}\n\n.approval-action-button.mark-paid:not(:disabled) {\n    border-color: #24a148;\n    background: #24a148;\n    color: #ffffff;\n}\n\n.approval-action-button.mark-paid:not(:disabled):hover {\n    border-color: #1f8f3f;\n    background: #1f8f3f;\n    color: #ffffff;\n}\n\n.pdf-viewer-frame {\n    width: 100%;\n    min-height: 640px;\n    display: flex;\n    align-items: stretch;\n    justify-content: center;\n    box-sizing: border-box;\n    padding: 0 18px;\n    background: #f7f9fc;\n    overflow: hidden;\n}\n\n.pdf-viewer-embed {\n    width: min(100%, 860px);\n    max-width: 100%;\n    height: calc(100vh - 260px);\n    min-height: 640px;\n    border: 0;\n    display: block;\n    background: #ffffff;\n}\n\n.invoice-preview-panel .pdf-viewer-frame {\n    min-height: 680px;\n}\n\n.invoice-preview-panel .pdf-viewer-embed {\n    height: calc(100vh - 270px);\n    min-height: 680px;\n}\n\n.invoice-create-page,\n.management-page {\n    width: 100%;\n    max-width: 1480px;\n}\n\n.invoice-create-page .step-indicator,\n.invoice-create-page [class*=\"step\"] {\n    max-width: 760px;\n}\n\n.invoice-upload-card {\n    max-width: 640px;\n    min-height: 260px;\n    margin-top: 18px;\n    padding: 32px;\n    border: 1px dashed #9ab2c9;\n    border-radius: 8px;\n    background: #ffffff;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n.upload-card-kicker {\n    margin-bottom: 8px;\n    color: #64748b;\n    font-size: 12px;\n    font-weight: 800;\n    text-transform: uppercase;\n}\n\n.invoice-upload-card h2 {\n    margin: 0;\n    color: #172033;\n    font-size: 26px;\n    font-weight: 800;\n}\n\n.invoice-upload-card p {\n    max-width: 460px;\n    margin: 10px 0 20px;\n    color: #66758a;\n    font-size: 14px;\n    line-height: 1.55;\n}\n\n.primary-action-button {\n    min-height: 40px;\n    padding: 0 16px;\n    border: 0;\n    border-radius: 8px;\n    background: #1f6feb;\n    color: #ffffff;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 800;\n}\n\n.primary-action-button:hover {\n    background: #195fc8;\n}\n\n.invoice-create-workspace {\n    margin-top: 18px;\n}\n\n.invoice-create-toolbar {\n    margin-bottom: 14px;\n}\n\n.invoice-submit-layout {\n    display: grid;\n    grid-template-columns: minmax(420px, 1.25fr) minmax(360px, 0.75fr);\n    gap: 18px;\n    align-items: start;\n}\n\n.invoice-create-layout {\n    display: grid;\n    grid-template-columns: minmax(380px, 1fr) minmax(360px, 0.9fr);\n    gap: 18px;\n    align-items: start;\n}\n\n.invoice-form-panel,\n.invoice-submit-panel,\n.invoice-approval-panel {\n    min-width: 0;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    background: #ffffff;\n    padding: 18px;\n}\n\n.invoice-form-panel .invoice-container {\n    margin-left: 0;\n    padding: 0;\n}\n\n.invoice-form-panel .input-group,\n.invoice-form-panel .input-group-small {\n    flex-wrap: wrap;\n    gap: 8px;\n}\n\n.invoice-form-panel .input-group label,\n.invoice-form-panel .input-group-small label {\n    min-width: 100%;\n    margin: 0;\n    color: #3c4a5f;\n    font-size: 13px;\n    font-weight: 800;\n}\n\n.invoice-form-panel .input-group .ant-select,\n.invoice-form-panel .input-group-small .ant-select,\n.invoice-form-panel .input-group input,\n.invoice-form-panel .input-group-small input {\n    width: 100% !important;\n}\n\n.invoice-form-panel .submit-button,\n.submit-form button {\n    width: 100% !important;\n    margin-left: 0 !important;\n    border-radius: 8px !important;\n}\n\n.invoice-form-panel .add-vendor {\n    width: 100%;\n}\n\n.invoice-submit-layout {\n    margin-top: 18px;\n}\n\n.invoice-submit-panel .container {\n    margin: 0;\n}\n\n.invoice-submit-panel .back-button-container {\n    margin: 0 0 16px;\n}\n\n.invoice-submit-panel .back-button {\n    border: 1px solid #dbe4ee;\n    background: #ffffff;\n}\n\n.invoice-approval-panel .controller-form {\n    width: 100%;\n    height: auto;\n    margin: 0;\n    padding: 0;\n    background: transparent;\n    border-radius: 0;\n}\n\n.invoice-approval-panel .input-group-controller {\n    flex-direction: column;\n    gap: 8px;\n    margin: 0;\n}\n\n.invoice-approval-panel .input-group-controller label {\n    margin: 0;\n    align-self: flex-start;\n    color: #3c4a5f;\n    font-size: 13px;\n    font-weight: 800;\n}\n\n.invoice-approval-panel .input-group-controller .ant-select {\n    width: 100% !important;\n    margin: 0;\n}\n\n.management-grid {\n    display: grid;\n    grid-template-columns: minmax(300px, 360px) minmax(0, 1fr);\n    gap: 18px;\n    align-items: start;\n}\n\n.management-form-card,\n.management-list-card,\n.role-assignment-card {\n    min-width: 0;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    background: #ffffff;\n    padding: 18px;\n}\n\n.management-list-card.full-width {\n    width: 100%;\n}\n\n.card-heading {\n    margin-bottom: 16px;\n}\n\n.card-heading h2,\n.list-panel-heading h2 {\n    margin: 0;\n    color: #172033;\n    font-size: 18px;\n    font-weight: 800;\n}\n\n.card-heading p,\n.list-panel-heading p {\n    margin: 6px 0 0;\n    color: #68778c;\n    font-size: 13px;\n    line-height: 1.45;\n}\n\n.compact-form form {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.form-field {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n\n.form-field span {\n    color: #3c4a5f;\n    font-size: 13px;\n    font-weight: 800;\n}\n\n.list-panel-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 14px;\n    margin-bottom: 14px;\n}\n\n.list-panel-actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.list-search {\n    width: min(320px, 100%);\n}\n\n.list-panel-actions .ant-select {\n    width: 220px;\n}\n\n.data-table-shell {\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    background: #ffffff;\n    overflow: hidden;\n}\n\n.management-table .ant-table-thead > tr > th {\n    background: #f8fafc;\n    color: #314056;\n    font-size: 12px;\n    font-weight: 800;\n    white-space: nowrap;\n}\n\n.management-table .ant-table-tbody > tr > td {\n    color: #263349;\n    font-size: 13px;\n}\n\n.management-table .ant-table-tbody > tr:hover > td {\n    background: #f5f9fd;\n    cursor: pointer;\n}\n\n.management-table .ant-select {\n    width: 100%;\n}\n\n.role-assignment-card {\n    margin-bottom: 16px;\n}\n\n.role-assignment-toolbar {\n    display: grid;\n    grid-template-columns: minmax(240px, 1fr) minmax(220px, 0.6fr) auto;\n    gap: 10px;\n}\n\n@media (max-width: 768px) {\n    .app-header {\n        height: 64px;\n        padding: 0 14px;\n    }\n\n    .header-left {\n        gap: 10px;\n    }\n\n    .header-logo {\n        width: 116px;\n        height: 42px;\n    }\n\n    .header-user-email,\n    .header-role-badge {\n        display: none;\n    }\n\n    .header-user-name {\n        max-width: 120px;\n        font-size: 13px;\n    }\n\n    .header-user-avatar {\n        width: 34px;\n        height: 34px;\n        font-size: 12px;\n    }\n\n    .sidebar-toggle-button,\n    .header-logout-button {\n        width: 38px;\n        height: 38px;\n    }\n\n    .left-bar,\n    .left-bar.collapsed {\n        position: fixed;\n        top: 64px;\n        left: 0;\n        bottom: 0;\n        z-index: 50;\n        width: 260px;\n        height: calc(100vh - 64px);\n        flex-basis: auto;\n        transform: translateX(-100%);\n        box-shadow: 18px 0 32px rgba(9, 30, 66, 0.18);\n    }\n\n    .left-bar.mobile-open {\n        transform: translateX(0);\n    }\n\n    .left-bar.collapsed .left-bar-header {\n        align-items: flex-start;\n        padding: 8px 10px 16px;\n    }\n\n    .left-bar.collapsed .left-bar-kicker,\n    .left-bar.collapsed .left-bar-title,\n    .left-bar.collapsed .left-bar-label {\n        display: inline;\n    }\n\n    .left-bar.collapsed .left-bar-link {\n        justify-content: flex-start;\n        padding: 10px 12px;\n    }\n\n    .app-content {\n        width: 100%;\n        padding: 16px;\n    }\n\n    .page-heading-row,\n    .invoice-detail-header,\n    .invoice-history-toolbar {\n        align-items: stretch;\n        flex-direction: column;\n    }\n\n    .page-metrics {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        width: 100%;\n    }\n\n    .invoice-history-search,\n    .invoice-history-actions {\n        width: 100%;\n    }\n\n    .invoice-history-actions {\n        justify-content: stretch;\n    }\n\n    .invoice-history-actions .ant-btn {\n        flex: 1;\n    }\n\n    .invoice-table-shell {\n        overflow: visible;\n    }\n\n    .invoice-history-table .ant-table {\n        border: 1px solid #e2e9f2;\n        border-radius: 8px;\n        overflow: hidden;\n    }\n\n    .invoice-history-table .ant-table-pagination.ant-pagination {\n        justify-content: center;\n        flex-wrap: wrap;\n        gap: 6px 4px;\n        margin: 14px 0 0;\n    }\n\n    .invoice-history-table .ant-pagination-options {\n        display: none;\n    }\n\n    .invoice-detail-title-group {\n        flex-direction: column;\n    }\n\n    .invoice-detail-header-actions {\n        justify-content: flex-start;\n    }\n\n    .invoice-detail-layout {\n        grid-template-columns: 1fr;\n    }\n\n    .invoice-create-layout,\n    .invoice-submit-layout,\n    .management-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .invoice-preview-panel {\n        min-height: 520px;\n    }\n\n    .pdf-viewer-frame,\n    .pdf-viewer-embed,\n    .invoice-preview-panel .pdf-viewer-frame,\n    .invoice-preview-panel .pdf-viewer-embed {\n        min-height: 520px;\n        height: 520px;\n    }\n\n    .list-panel-heading,\n    .list-panel-actions,\n    .role-assignment-toolbar {\n        align-items: stretch;\n        grid-template-columns: 1fr;\n        flex-direction: column;\n    }\n\n    .list-search {\n        width: 100%;\n    }\n\n    .sidebar-backdrop {\n        position: fixed;\n        top: 64px;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        z-index: 45;\n        display: block;\n        border: 0;\n        background: rgba(8, 24, 43, 0.42);\n        cursor: pointer;\n    }\n}\n\n@media (max-width: 520px) {\n    .header-user-copy {\n        display: none;\n    }\n\n    .app-content {\n        padding: 12px;\n    }\n\n    .page-metrics {\n        grid-template-columns: 1fr;\n    }\n\n    .page-heading-copy h1,\n    .invoice-detail-title-group h1 {\n        font-size: 24px;\n    }\n\n    .invoice-workflow-panel {\n        padding: 14px;\n    }\n\n    .approval-action-row {\n        grid-template-columns: 1fr;\n    }\n\n    .invoice-upload-card,\n    .management-form-card,\n    .management-list-card,\n    .role-assignment-card,\n    .invoice-form-panel,\n    .invoice-submit-panel,\n    .invoice-approval-panel {\n        padding: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
